import { Component, OnInit } from '@angular/core';
import {DatePipe, Location} from '@angular/common';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { AppointmentService } from 'src/app/services/appointment.service';
import { RegistorpatientService } from 'src/app/services/registorpatient.service';
import { PatientPersonalInfo, VerifypatientModule } from 'src/app/models/verifypatient/verifypatient';
import { VerifypatientService } from 'src/app/services/verifypatient.service';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import moment from 'moment';
import { type } from 'os';
import { IntakeMedicationService } from '../../services/intake-Medication.service';
import { TranslateService } from '@ngx-translate/core';
declare var $:any;
@Component({
  selector: 'app-finalappointmentmessage',
  templateUrl: './finalappointmentmessage.component.html',
  styleUrls: ['./finalappointmentmessage.component.css']
})
export class FinalappointmentmessageComponent implements OnInit {
  
  patientpersonalinfo:any;
  patientpersonalinfoCheckin:any;
  appointment_details: any;
  isWithin24Hours: any;
  isWithin3Hours: any;
  VerifypatientModule = new VerifypatientModule();
  appointmentAddress: any;
  appointmentState: any;
  appointmentCity: any;
  appointmentZip: any;
  IslandeFromQRCode: boolean = false;
  selectedLanguage: any = 'en';
  currentLang: any = 'en';
  constructor(private location:Location,private spinner: NgxSpinnerService, private _phrutilService: PhrutillsService, private appoint: AppointmentService, private datepipe: DatePipe,private _registor: RegistorpatientService
    , private _router: Router, private _VerifypatientService: VerifypatientService, private updateinfoservice: UpdateinfoService, private medicationService: IntakeMedicationService, private translateService: TranslateService) { 
      let info = localStorage.getItem('PatientInfo');
      if(!info){
        this._router.navigateByUrl("/home?practice_code=''");
        return;
      }
    }
  isFromcheckin: boolean = false;
    ngOnInit(): void {
      this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
      const checkinDetails = localStorage.getItem('PatientInfoCheckin');
      if (checkinDetails != null && checkinDetails != undefined) {
        this.isFromcheckin = true;
        this._phrutilService.patientlanguage$.subscribe(language => {
         // console.log("dafault " + language);
          if (language === 'es') {
            this.currentLang = language;
            this._phrutilService.setTitle('Regístrese para una cita');
          } else if (language === 'hi') {
            this.currentLang = language;
            this._phrutilService.setTitle('अपॉइंटमेंट के लिए चेक-इन करें');
          } else if (language === 'ur') {
            this.currentLang = language;
            this._phrutilService.setTitle('اپوائنٹمنٹ کے لیے چیک ان کریں');
          }
          else {
            this.currentLang = 'en';
            this._phrutilService.setTitle('Check-in for Appointment');
          }
        });
        this.patientpersonalinfoCheckin = this._phrutilService.decrypt(checkinDetails);
        //console.log(this.patientpersonalinfoCheckin);
        this.appointmentAddress = this.patientpersonalinfoCheckin.appointmentAddress ? this.patientpersonalinfoCheckin.appointmentAddress : this.patientpersonalinfoCheckin.practiceAddress;
        this.appointmentState = this.patientpersonalinfoCheckin.appointmentState ? this.patientpersonalinfoCheckin.appointmentState : this.patientpersonalinfoCheckin.practiceState;
        this.appointmentCity = this.patientpersonalinfoCheckin.appointmentCity ? this.patientpersonalinfoCheckin.appointmentCity : this.patientpersonalinfoCheckin.PracticeCity;
        this.appointmentZip = this.patientpersonalinfoCheckin.appointmentZip ? this.patientpersonalinfoCheckin.appointmentZip : this.patientpersonalinfoCheckin.praticeZip;
        localStorage.setItem("apptAddr", this.appointmentAddress);
        localStorage.setItem("apptst", this.appointmentState);
        localStorage.setItem("apptcty", this.appointmentCity);
        localStorage.setItem("aptzip", this.appointmentZip);
      } else {
        this._phrutilService.patientlanguage$.subscribe(language => {
        //  console.log("dafault " + language);
          if (language === 'es') {
            this.currentLang = language;
            this._phrutilService.setTitle('Reserve una cita');
          } else if (language === 'hi') {
            this.currentLang = language;
            this._phrutilService.setTitle('अपॉइंटमेंट बुक करें');
          } else if (language === 'ur') {
            this.currentLang = language;
            this._phrutilService.setTitle('اپوائنٹمنٹ بک کریں');
          }
          else {
            this.currentLang = 'en';
            this._phrutilService.setTitle('Book an Appointment');
          }
        });
      }
      if (this.patientpersonalinfoCheckin && this.patientpersonalinfoCheckin.firstName != undefined && this.patientpersonalinfoCheckin.firstName != null) {
        this.patientpersonalinfo.first_Name = this.patientpersonalinfoCheckin.firstName;
      }
      if (this.patientpersonalinfoCheckin && this.patientpersonalinfoCheckin.lastName != undefined && this.patientpersonalinfoCheckin.lastName != null) {
        this.patientpersonalinfo.last_Name = this.patientpersonalinfoCheckin.lastName;
      }
      //console.log(this.patientpersonalinfoCheckin);
      //console.log(this.patientpersonalinfo);
     // console.log("this is patient_Account console " + this.patientpersonalinfo.patient_Account)
      this.getAppointmentDetails();
      if (this.isFromcheckin==true) {
        this.checkinthroughexiting();
      }
      const landfrom = localStorage.getItem("landFrom");
      if (landfrom != undefined && landfrom != null && landfrom == 'qrcode') {
        this.IslandeFromQRCode = true;
        this._phrutilService.setTitle('Verify Patient');
        this._phrutilService.setNavpracName(this.patientpersonalinfoCheckin.practiceName);
        $("#language-modal").modal("show");
      }
    }
    backPage()
    {
      this.location.back();
  }

  selectLanguage(language: string) {
    this.selectedLanguage = language;
    this.currentLang = language;
    this.onLanguageChange();

  }
  onLanguageChange() {
    this.translateService.use(this.selectedLanguage)
    localStorage.setItem('language', this.selectedLanguage);
    // console.log("lang verify modal " + this.selectedLanguage);
    this._phrutilService.setdeafultLanguage(this.selectedLanguage);
    this._phrutilService.setPatientLanguage(this.selectedLanguage);
    this._phrutilService.setTitle('Verify Patient');
    this._phrutilService.setNavpracName(this.patientpersonalinfoCheckin.practiceName);
    this.currentLang = this.selectedLanguage;
    $("#language-modal").modal("hide");
    //console.log("onLanguageChange");
  }

  phoneLink: any;
  getAppointmentDetails() {
    if (this.patientpersonalinfoCheckin && this.patientpersonalinfoCheckin.practiceCode != undefined && this.patientpersonalinfoCheckin.practiceCode != null) {
      this.patientpersonalinfo.practice_code = this.patientpersonalinfoCheckin.practiceCode;
    }
    if (this.patientpersonalinfoCheckin && this.patientpersonalinfoCheckin.patientAccount != undefined && this.patientpersonalinfoCheckin.patientAccount !=null) {
      this.patientpersonalinfo.patient_Account=this.patientpersonalinfoCheckin.patientAccount;
    }
    if (this.patientpersonalinfoCheckin && this.patientpersonalinfoCheckin.appointment_id != undefined && this.patientpersonalinfoCheckin.appointment_id !=null) {
      this.patientpersonalinfo.appointmentid = this.patientpersonalinfoCheckin.appointment_id;
    }
      this.spinner.show();
      this.appoint.getAppointmentDetails(this.patientpersonalinfo.practice_code,this.patientpersonalinfo.patient_Account,this.patientpersonalinfo.appointmentid).subscribe((res:any)=>{
        this.spinner.hide();
        if(res.statusCode==200)
        {
          this.appointment_details = res.data;
          this.appointment_details.praC_PHONE = this._phrutilService.maskingPhoneNumer(this.appointment_details.praC_PHONE);
          // Original date string
          const appointmentDateTimeString = this.appointment_details.appointment_Date_Time;
          const appointmentDateTime = new Date(appointmentDateTimeString);
          const appointmentDate = appointmentDateTime.toLocaleDateString();
          this.appointment_details.praC_ZIP = this.appointment_details.praC_ZIP.length > 5 ? this._phrutilService.maskingZipNum(this.appointment_details.praC_ZIP) : this.appointment_details.praC_ZIP;
          if (this.appointment_details?.praC_PHONE) {
            this.phoneLink = "tel:+1" + this.appointment_details?.praC_PHONE;
          }
          if (this.isFromcheckin != true) {
            this.appointmentAddress = this.appointment_details.praC_ADDRESS;
            this.appointmentState = this.appointment_details.praC_STATE;
            this.appointmentCity = this.appointment_details.praC_CITY;
            this.appointmentZip = this.appointment_details.praC_ZIP;
          }
   
          /*
          localStorage.setItem('visitDate', appointmentDate)
          localStorage.setItem("pcode", this.patientpersonalinfo.practice_code);
          localStorage.setItem("reason", this.patientpersonalinfo.reasonName);
          localStorage.setItem("state", this.appointment_details.praC_STATE);
          localStorage.setItem("city", this.appointment_details.praC_CITY);
          localStorage.setItem("zip", this.appointment_details.praC_ZIP);
          localStorage.setItem("prcode", this.patientpersonalinfo.provider_Code);
          localStorage.setItem("ptcode", this.patientpersonalinfo.patient_Account);
          console.log("appointmetn date " + appointmentDate);
          console.log("reason" + this.patientpersonalinfo.reasonName);
          console.log("time from " + this.appointment_details.time_From);
          console.log("using zahid function " + this.ConverttoLocalDate(appointmentDate));
          this.isWithin3Hours = this.checkinBeforeThreeHours(appointmentDate, this.appointment_details.time_From);
          localStorage.setItem('isWithin3Hours', this.isWithin3Hours);
          console.log("is within 3 hours before "+this.isWithin3Hours);
          if ((this.patientpersonalinfo.practice_code == '1011163' || this.patientpersonalinfo.practice_code == '100') && this.patientpersonalinfo.reasonName == 'Initial Visit') {
            this.isWithin24Hours = this.checkIfVisitWithin24Hours(appointmentDate, this.appointment_details.time_From);
            console.log("in final appointment " +this.isWithin24Hours); // Output: true or false
            localStorage.setItem('isWithin24Hours', this.isWithin24Hours);
          }
          */
        }
      },(error:any)=>{
        this.spinner.hide();
      })
    }
    checkin()
    {
      if (this.isdataScienceCallFailed) {
        this.checkinthroughexiting();
      } else {
        this._router.navigateByUrl('/patient/consent-form');
      }
      
  }
  isdataScienceCallFailed: boolean = false;
    checkinthroughexiting()
    {
      this.spinner.show();
    /*  alert(this.patientpersonalinfo.date_Of_Birth);*/
      this.VerifypatientModule.PRACTICE_CODE = this.patientpersonalinfoCheckin.practiceCode;
      //this.VerifypatientModule.PRACTICE_CODE = '1011163';
      this.VerifypatientModule.LAST_NAME = this.patientpersonalinfoCheckin.lastName;
      this.VerifypatientModule.FIRST_NAME = this.patientpersonalinfoCheckin.firstName;
      this.VerifypatientModule.DOB = this.datepipe.transform(this.patientpersonalinfoCheckin.dateOfBirth, 'MM/dd/yyyy');
      this.VerifypatientModule.APPOINTMENT_ID = this.patientpersonalinfoCheckin.appointment_id;
    /*  alert(this.VerifypatientModule.DOB);*/
      this._VerifypatientService.VerifyPatient_v1(this.VerifypatientModule)
        .pipe(
          catchError((error) => {
            this.spinner.hide();
            if (error.status === 0) {
              console.error('Network error or CORS issue.');
              // Handle network error or CORS issue specifically
             /* alert("Network error or CORS issue.");*/
            } else {
              console.error('An error occurred:', error);
            /*  alert(error);*/
            }
            this.isdataScienceCallFailed = true;
            return of(null); // Return a null observable to gracefully handle the error
          })
        ).subscribe((res: any) => {
        
        this.spinner.hide();
        if (res.RESPONSE[0]) {
          
          let PatientPersonalInfo = res.RESPONSE[0] as PatientPersonalInfo;
          PatientPersonalInfo.PRACTICE_CODE = this.VerifypatientModule.PRACTICE_CODE;
          PatientPersonalInfo.isShowpicture = true;
          PatientPersonalInfo.PracticeName = this.patientpersonalinfo.practice_name;
          PatientPersonalInfo.PROVIDER_CODE = this.patientpersonalinfoCheckin.providerCode;
          let data = this._phrutilService.encrypt(PatientPersonalInfo);
          localStorage.setItem('PersonalInfo', data);
          localStorage.setItem("AuthToken",res.RESPONSE[0].ACCESS_TOKEN);
          this.updateinfoservice.onIsShowProfilePic();
          this._VerifypatientService.startRefreshTokenTimer();
          if (this.isdataScienceCallFailed) {
             this._router.navigateByUrl('/patient/consent-form');
          }
        } else {
          $("#incorrectinfo-model").modal("show");
        }
      }, (error: any) => {
        //alert(error);
        //console.log(error+"error");
       // $("#incorrectinfo-model").modal("show");
          this.spinner.hide();
          this.isdataScienceCallFailed = true;
      })
  }

 
  getCurrentDateFormatted(): string {
    const currentDate = this.ConverttoLocalDate(new Date());
    console.log("current date before format " + currentDate);
    const month = currentDate.getMonth() + 1; // Months are zero-based
    const day = currentDate.getDate();
    const year = currentDate.getFullYear();

    return `${month}/${day}/${year}`;
  }
  getNextDayFormatted(): any {
    const currentDate = this.ConverttoLocalDate(new Date());
    currentDate.setDate(currentDate.getDate() + 1); // Add one day to the current date

    return this.ConverttoLocalDateInDay(currentDate);
  }
  checkIfVisitWithin24Hours(visitDate: string, visitTime: string): boolean {

    //const visitDateTime = new Date(visitDate);
    const visitDateTime = this.ConverttoLocalDate(visitDate);
    console.log("visit date time " + visitDateTime);
    //console.log("visit date time " + typeof visitDateTime);
  

    const currentDateFormatted = this.getCurrentDateFormatted();
    console.log("current date with format " + currentDateFormatted)

    const currentDateTime = this.ConverttoLocalDate(currentDateFormatted);
    console.log("current date time " + currentDateTime);
    //console.log("current date time "+ typeof currentDateTime);
    const nextDayformated = this.getNextDayFormatted();
    console.log("next day formated" + nextDayformated)


    const nextDaydate = this.ConverttoLocalDate(nextDayformated);
    console.log("next day date " + nextDaydate);
   // console.log("next day date " + typeof nextDaydate);



 

    if ((visitDateTime == currentDateTime) || (visitDateTime == nextDaydate)) {
      return true;
    } else {
      return false;
    }


    // Compare the year, month, and date components
    //const isSameDate = visitDateTime.getFullYear() === currentDateTime.getFullYear() &&
    //  visitDateTime.getMonth() === currentDateTime.getMonth() &&
    //  visitDateTime.getDate() === currentDateTime.getDate();

 

    /*
    // Parse the visit date and time into a Date object
    const visitDateTime = new Date(`${visitDate} ${visitTime}`);

    // Get the current date and time
    const currentDateTime = new Date();

    // Calculate the difference in milliseconds
    const diffInMs = visitDateTime.getTime() - currentDateTime.getTime();

    // Convert the difference to hours
    const diffInHours = diffInMs / (1000 * 60 * 60);
    console.log(" time difference "+diffInHours);
    // Check if the difference is within 24 hours
    return diffInHours <= 24 && diffInHours >= 0; */
  }
  ConverttoLocalDate(date: any): Date {
    // if (!date) return '';

    if (date instanceof Date) {
      date = this.hasTimezone(date) ? this.removeZ(date) : date;
      date = moment(date).format('MM/DD/Y h:mm:ss');
      date = new Date(date);
    }

    return date;
  }


  private hasTimezone(value: any) {
    if (typeof value !== 'string') return false;
    return (value.includes('T') || value.includes('t'));
  }

  private removeZ(value: any) {
    if (!value) return '';
    return value.replace(/z|Z/, '');
  }


  ConverttoLocalDateInDay(date: any): string {
    if (date instanceof Date) {
      // Ensure the date is in the local timezone and format without leading zeros
      const month = date.getMonth() + 1; // Months are zero-based, so add 1
      const day = date.getDate();
      const year = date.getFullYear();

      return `${month}/${day}/${year}`;
    }
    return date;
  }

  checkinBeforeThreeHours(visitDate: any, visitTime: any) {
    try {
      // Combine visitDate and visitTime into a single string
      const visitDateTimeStr = `${visitDate} ${visitTime}`;

      // Parse visit date and time into a Date object without converting to local timezone
      const visitDateTime = this.ConverttoLocalDateForDiff(visitDateTimeStr);
      console.log("3 hour visit date time: " + visitDateTime);

      // Get the current date and time in UTC
      const currentDateTime = this.ConverttoLocalDateForDiff(new Date());
      console.log("3 hour current date time: " + currentDateTime);

      // Calculate the difference in milliseconds
      const diffInMs = visitDateTime.getTime() - currentDateTime.getTime();

      // Convert the difference to hours
      const diffInHours = diffInMs / (1000 * 60 * 60);
      console.log("3 hour difference: " + diffInHours);

      // Check if the difference is within 3 hours
      return diffInHours <= 3 && diffInHours >= 0;
    } catch (error) {
      console.error("An error occurred while calculating the time difference:", error);
      // Return false if an error occurs
      return false;
    }

  }
  ConverttoLocalDateForDiff(date: any): Date {
    // if (!date) return '';

    // if (date instanceof Date) {
    date = this.hasTimezone(date) ? this.removeZ(date) : date;

    date = moment(date).format('MM/DD/Y h:mm:ss');
    //date = moment(date).format('MM/DD/YYYY');
    date = new Date(date);

    // }

    return date;
  }

  }
